import AScene from "../../library/ExtendedObjects/AScene.js";
import IntroTitle from "./IntoTitle.js";
import Rivette from "./Rivette.js";
import gameData from "../../gameData.js";
import ABCyaPhaser from "@abcya/abcya_phaser";
import FontKeys from "../../FontKeys.js";
import ABCyaLib from "@abcya/abcya_lib";
import TestSentenceScene from "../Debugger/TestSentenceScene.js";

export default class Intro extends AScene {
  static get KEY() { return 'Intro'; }

  create() {
    gameData.score = 0;
    gameData.round = 1;
    gameData.gameOver = false;
    gameData.gamePaused = false;

    this.addImage(this.mid.x, this.mid.y, "Bckg1Large");
    this.gradient = this.addImage(this.mid.x, 220, "TitleScreenGradient");
    this.gradient.alpha = 0;

    this.createPulses();
    this.createRivette();
    this.createPlay();

    if (!gameData.jingleOn) {
      this.playSound("jingle", .3, true);
      gameData.jingleOn = true;
    }

    this.addTween(this.gradient, 1000, { alpha: 1 }, Phaser.Math.Easing.None);

    this.logo = this.addContainer(this.mid.x / 2 + 50, this.mid.y - 75, new IntroTitle(this), this);

    if(ABCyaLib.Environment.instance.environment !== ABCyaLib.Environment.ENVIRONMENTS.production){
      // add a cheat to unlock all artifacts when not on prod
      this.input.keyboard.once(Phaser.Input.Keyboard.Events.KEY_UP + "SPACE", ()=>{
        gameData.collectedArtifacts = [...gameData.collectedArtifacts, ...gameData.artifacts];
        gameData.artifacts = [];
      });
      this.input.keyboard.on(Phaser.Input.Keyboard.Events.KEY_UP + "ENTER", ()=>{
        this.scene.run(TestSentenceScene.KEY);
        this.scene.pause();
      });
    }
  }

  createRivette() {
    this.rivette = new Rivette(this, 1400, 500, "intro");

    //hack way of preventing the "blipping effect"
    this.rivette.character.spine.setDepth(-1);
    this.addDelay(50, () => { this.tweenInRivette(); });
  }

  tweenInRivette() {
    this.rivette.character.spine.setDepth(2);

    this.addDelay(1000, () => { this.playSound("footsteps"); });

    this.addTween(this.rivette.character.spine, 2000, { x: 800 }, Phaser.Math.Easing.None,
      () => { this.rivette.playAnimation("idle", true); });
  }

  createPlay() {
    this.play = this.addButton(440, 670, "PlayBtn", {}, () => { this.tweenOutIntro("Game") });
    this.playText = ABCyaPhaser.Text.addText(this.play.x, this.play.y + 28, 20, 0x5e3423, FontKeys._Tertre_Med, ABCyaPhaser.Localization.instance.getLocalizedString('play'), this);
    this.museum = this.addButton(600, 670, "MuseumBtn", {}, () => { this.tweenOutIntro("Museum") });
    this.museumText = ABCyaPhaser.Text.addText(this.museum.x, this.museum.y + 28, 20, 0x5e3423, FontKeys._Tertre_Med, ABCyaPhaser.Localization.instance.getLocalizedString('museum'), this);

    this.play.alpha = 0;
    this.playText.alpha = 0;
    this.museum.alpha = 0;
    this.museumText.alpha = 0;
  }

  createPulses() {
    this.glowOrange = this.addImage(this.mid.x / 2 + 50, this.mid.y - 75, 'LogoRingOrange');
    this.glowBlue = this.addImage(this.mid.x / 2 + 50, this.mid.y - 75, 'LogoRingBlue');

    this.orangeMask = this.addSquareMask(this.glowOrange, -220, 45, 250, 230);
    this.blueMask = this.addSquareMask(this.glowBlue, 590, 325, 250, 230);

    this.glowOrange.alpha = 0;
    this.glowBlue.alpha = 0;
  }

  tweenPulses(type) {
    if (type === "orange") {
      this.playSound("energy_beam_2");
      this.playSound("intro_background_noise");

      this.addTween(this.orangeMask, 200, { x: 240, y: -20 }, Phaser.Math.Easing.None);
    }
    else if (type === "blue") {
      this.playSound("energy_beam_1");

      this.addTween(this.blueMask, 200, { x: -250, y: 30 }, Phaser.Math.Easing.None);
    }
  }

  tweenOutIntro(dest) {
    this.playSound("click");

    this.logo.endPulse();
    this.play.setEnabled(false);
    this.museum.setEnabled(false);

    this.rivette.character.spine.setScale(.75, .75);
    this.rivette.playAnimation("walk", true);

    this.addTween(this.gradient, 1000, { alpha: 0 }, Phaser.Math.Easing.None);
    this.addTween(this.rivette.character.spine, 1300, { x: 1200 }, Phaser.Math.Easing.None);
    this.addTween(this.logo, 1000, { x: -300, delay: 300 }, Phaser.Math.Easing.Back.In);
    this.addTween(this.glowOrange, 300, { alpha: 0 }, Phaser.Math.Easing.Back.In);
    this.addTween(this.glowBlue, 300, { alpha: 0 }, Phaser.Math.Easing.Back.In);
    this.addTween(this.museum, 1000, { alpha: 0, delay: 300 }, Phaser.Math.Easing.None);
    this.addTween(this.museumText, 1000, { alpha: 0, delay: 300 }, Phaser.Math.Easing.None);
    this.addTween(this.playText, 1000, { alpha: 0, delay: 300 }, Phaser.Math.Easing.None);
    this.addTween(this.play, 1000, { alpha: 0, delay: 300 }, Phaser.Math.Easing.None,
      () => { this.cleanUp(dest); });
  }

  showPlay() {
    this.addTween(this.play, 300, { alpha: 1 }, Phaser.Math.Easing.None);
    this.addTween(this.museum, 300, { alpha: 1 }, Phaser.Math.Easing.None);
    this.addTween(this.museumText, 300, { alpha: 1 }, Phaser.Math.Easing.None);
    this.addTween(this.playText, 300, { alpha: 1 }, Phaser.Math.Easing.None);
  }

  cleanUp(destination) {
    this.killTween(this.orangeMask);
    this.killTween(this.blueMask);
    this.blueMask.destroy();
    this.orangeMask.destroy();
    this.glowBlue.destroy();
    this.glowOrange.destroy();

    this.rivette.cleanUp();
    this.rivette.destroy();

    this.logo.cleanUp();
    this.logo.destroy();

    this.play.destroy();
    this.museum.destroy();
    this.museumText.destroy();
    this.playText.destroy();

    this.scene.start(destination);
  }
}